import React from 'react'
import styles from './TaskList.module.scss'
import { TaskItem } from '..'
import { buildTasks } from '../../helpers/helpers'
import { useComponentLocale } from '../../hooks/useComponentLocale'

function TaskList({ taskList, onButtonStatusClicked, openLog }) {
	const getLocale = useComponentLocale()

	const doneStatusLocale = getLocale({ component: 'tags', section: 'done_tag' })
	const parsedStatusLocale = getLocale({ component: 'tags', section: 'parsed' })
	const noLicenseStatusLocale = getLocale({ component: 'tags', section: 'no_license' })
	const runningStatusLocale = getLocale({ component: 'tags', section: 'running' })

	const tasks = buildTasks(taskList, doneStatusLocale, parsedStatusLocale, noLicenseStatusLocale, runningStatusLocale)

	return (
		<div className={styles.container}>
			{tasks.map((task, index) => (
				<TaskItem
					key={index}
					item={task.item}
					onButtonStatusClicked={onButtonStatusClicked}
					isRunEnabled={task.isRunEnabled}
					isRemoveEnabled={task.isRemoveEnabled}
					onButtonLogClicked={openLog}
					status={task.status}
					spots={task.spots}
				/>
			))}
		</div>
	)
}

export default TaskList
